var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackVerypoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#cc2334",
    cx: 50,
    cy: 50,
    r: 41.97
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7d161f",
    d: "M50,93.47c-23.97,0-43.47-19.5-43.47-43.47S26.03,6.53,50,6.53s43.47,19.5,43.47,43.47-19.5,43.47-43.47,43.47ZM50,9.53c-22.32,0-40.47,18.15-40.47,40.47s18.15,40.47,40.47,40.47,40.47-18.16,40.47-40.47S72.32,9.53,50,9.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#46161f",
    d: "M26.58,35.96c-.45-.03-.83.34-.83.79,0,.36.24.67.59.77,1.15.3,3.78,1.19,5.9,3.37-1.76,1.21-2.91,3.23-2.91,5.52,0,3.7,3,6.69,6.69,6.69s6.69-3,6.69-6.69c.01-8.96-12.72-10.26-16.13-10.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#46161f",
    d: "M73.42,35.96c-3.41.19-16.13,1.49-16.13,10.44,0,3.7,3,6.69,6.69,6.69s6.69-3,6.69-6.69c0-2.29-1.15-4.32-2.91-5.52,2.13-2.18,4.75-3.06,5.9-3.37.35-.09.59-.4.59-.77,0-.45-.38-.81-.83-.78Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#46161f",
    d: "M61.51,71.97c-.63,0-1.24-.31-1.6-.88-.14-.22-3.44-5.26-9.91-5.26s-9.79,5.07-9.93,5.29c-.58.87-1.75,1.11-2.62.54s-1.11-1.74-.55-2.61c.19-.29,4.66-7,13.1-7s12.94,6.74,13.12,7.03c.55.89.28,2.05-.6,2.61-.32.18-.66.28-1.01.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackVerypoor);
export default __webpack_public_path__ + "static/media/feedback-verypoor.67f190307f8bc46140cbcdc9d45f7cb3.svg";
export { ForwardRef as ReactComponent };